var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalDispatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 21.0001V7.00008C16.333 6.38124 16.0872 5.78775 15.6496 5.35017C15.212 4.91258 14.6185 4.66675 13.9997 4.66675H4.66634C4.0475 4.66675 3.45401 4.91258 3.01643 5.35017C2.57884 5.78775 2.33301 6.38124 2.33301 7.00008V19.8334C2.33301 20.1428 2.45592 20.4396 2.67472 20.6584C2.89351 20.8772 3.19026 21.0001 3.49967 21.0001H5.83301M5.83301 21.0001C5.83301 22.2887 6.87768 23.3334 8.16634 23.3334C9.45501 23.3334 10.4997 22.2887 10.4997 21.0001M5.83301 21.0001C5.83301 19.7114 6.87768 18.6667 8.16634 18.6667C9.45501 18.6667 10.4997 19.7114 10.4997 21.0001M17.4997 21.0001H10.4997M17.4997 21.0001C17.4997 22.2887 18.5443 23.3334 19.833 23.3334C21.1217 23.3334 22.1663 22.2887 22.1663 21.0001M17.4997 21.0001C17.4997 19.7114 18.5443 18.6667 19.833 18.6667C21.1217 18.6667 22.1663 19.7114 22.1663 21.0001M22.1663 21.0001H24.4997C24.8091 21.0001 25.1058 20.8772 25.3246 20.6584C25.5434 20.4396 25.6663 20.1428 25.6663 19.8334V15.5751C25.6659 15.3103 25.5754 15.0536 25.4097 14.8471L21.3497 9.77208C21.2406 9.63544 21.1021 9.52508 20.9446 9.44915C20.7871 9.37322 20.6145 9.33366 20.4397 9.33341H16.333",
    stroke: "#020617",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalDispatch);
export default __webpack_public_path__ + "static/media/externalDispatch.5a1ee765b63e4a828f65ed000d46ad3b.svg";
export { ForwardRef as ReactComponent };